import * as yup from 'yup';

export const validationSchema = yup.object({
  firstName: yup.string().required('app.error.field-required'),
  lastName: yup.string().required('app.error.field-required'),
  email: yup
    .string()
    .trim('app.error.email-spaces')
    .email('app.error.email-invalid')
    .required('app.error.email-required'),
});
